// Same-phone pass recovery — client half. After a successful enrollment we
// keep the server's signed recovery key in localStorage, keyed by program, so
// a customer who cancelled the wallet sheet, reloaded, or came back later can
// re-add their pass from THIS browser without staff. The key is only good for
// the one card it was minted for (see apps/api/src/services/pass-recovery-key.ts).
//
// localStorage can be missing or throw (private mode, blocked storage) — every
// access is guarded and failure just means the old "ask our staff" path.

export interface StoredRecovery {
  key: string
  firstName: string
  providersAvailable: string[]
}

function storageKey(programId: string): string {
  return `naya.passRecovery.${programId}`
}

export function loadRecovery(programId: string): StoredRecovery | null {
  try {
    const raw = localStorage.getItem(storageKey(programId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<StoredRecovery>
    if (typeof parsed.key !== 'string' || !parsed.key) return null
    return {
      key: parsed.key,
      firstName: typeof parsed.firstName === 'string' ? parsed.firstName : '',
      providersAvailable: Array.isArray(parsed.providersAvailable)
        ? parsed.providersAvailable
        : ['google'],
    }
  } catch {
    return null
  }
}

export function saveRecovery(programId: string, value: StoredRecovery): void {
  try {
    localStorage.setItem(storageKey(programId), JSON.stringify(value))
  } catch {
    // Storage unavailable — recovery falls back to staff.
  }
}

export function clearRecovery(programId: string): void {
  try {
    localStorage.removeItem(storageKey(programId))
  } catch {
    // ignore
  }
}
